import StyleButton from './StyleButton'

const BlockStyleControls = props => {
  const { classes, editorState, blockTypes } = props
  const selection = editorState.getSelection()
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType()

  const onMouseDown = event => {
    // Prevent focus stealing
    event.preventDefault()
  }

  if (blockTypes) {
    return (
      <div className={classes.controls} onMouseDown={onMouseDown}>
        {blockTypes.map(type => (
          <StyleButton
            key={type.label}
            active={type.style === blockType}
            label={type.label}
            onToggle={props.onToggle}
            style={type.style}
            classes={classes}
            icon={type.icon}
          />
        ))}
      </div>
    )
  } else {
    return null
  }
}

export default BlockStyleControls
